import React from 'react';
import banner from '../assets/images/new_banner.png';

const About = () => {
  return(
    <div className="min-h-screen bg-cover bg-center bg-no-repeat bg-fixed flex items-center justify-center" style={{backgroundImage: `url(${banner})`}}>
      {/* <div className="nav-bar absolute top-0 left-0 right-0 z-10 p-6">Stuff will go here</div> */}
      <div className="max-w-5xl mr-auto px-6 py-20">
        <div className="title-content backdrop-blur-2xl bg-white/10 dark:bg-black/20 rounded-3xl shadow-2xl border border-white/20 p-12 md:p-16 transition-all duration-500 hover:shadow-[0_20px_70px_rgba(0,0,0,0.3)]">
          <div className="about-body space-y-8">
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white tracking-tight leading-tight drop-shadow-lg text-left">
              Hi, I'm Justin!
            </h1>
            <p className="text-xl md:text-2xl text-white/90 font-light leading-relaxed max-w-4xl text-left">
              I’m a full-stack software engineer with 6 years of experience building scalable, user-focused applications using React, TypeScript, Node.js, Ruby on Rails, and Python. I specialize in developing modern frontend architectures, reliable backend services, and cloud-based solutions using technologies like PostgreSQL and AWS. Recently, I’ve focused on AI-powered applications, including LLM integrations, RAG systems, vector search, and agent workflows. I’ve delivered solutions across industries by building intuitive user experiences, secure APIs, automation tools, and production-ready software that solves real-world problems.
            </p>
          </div>
          <div className="about-links mt-12 flex gap-6 justify-center md:justify-start">
            <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UCLn0jCRt_zJfsMhR1WFswzw"
               className="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 backdrop-blur-sm border border-white/30 transition-all duration-300 hover:scale-110 hover:shadow-lg">
              <i className="fab fa-youtube text-white text-2xl"></i>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://github.com/Wyzardsleeves"
               className="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 backdrop-blur-sm border border-white/30 transition-all duration-300 hover:scale-110 hover:shadow-lg">
              <i className="fab fa-github text-white text-2xl"></i>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/justin-lattimore"
               className="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 backdrop-blur-sm border border-white/30 transition-all duration-300 hover:scale-110 hover:shadow-lg">
              <i className="fab fa-linkedin text-white text-2xl"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About;
